<template>
  <div
    :class="
      $b({
        visible: percentage < 100,
      })
    "
  >
    <div :class="$b('inner')">
      <svg :class="$b('circle-svg')">
        <circle
          ref="svgcircle"
          cx="21"
          cy="21"
          r="19"
          :class="$b('circle')"
          stroke="url('#IconGradient')"
          :stroke-dashoffset="svgPos"
          :stroke-dasharray="svgLength"
        />
        <defs>
          <linearGradient
            id="IconGradient"
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(20)"
          >
            <stop
              offset="0"
              stop-color="#5C0F99"
            />
            <stop
              offset="60%"
              stop-color="#3449B8"
            />
            <stop
              offset="100%"
              stop-color="#1799E1"
            />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
import { debounce } from '~/assets/js/helpers'

export default {
  name: 'ProgressSpinner',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    svgLength: 0,
    svgPos: 0,
    visible: false,
  }),
  watch: {
    percentage() {
      this.updateProgress()
    },
  },
  mounted() {
    this.hide = debounce(this.hide, 300)
    this.updateProgress()
  },
  methods: {
    updateProgress() {
      try {
        this.svgLength = Math.ceil(this.$refs.svgcircle.getTotalLength())
      } catch {
        /* do nothing, element likely isn't rendered yet */
      }

      const percentageLimit = Math.min(this.percentage, 100)
      const svgOffset = (this.svgLength / 100) * percentageLimit

      this.svgPos =
        this.svgLength === 0 ? 0 : Math.ceil(this.svgLength - svgOffset)

      if (this.percentage < 100) this.visible = true
      if (this.percentage === 100) this.hide()
    },
    hide() {
      this.visible = false
    },
  },
}
</script>

<style lang="postcss">
.ProgressSpinner {
  @apply absolute top-0 left-0 w-full h-full
    flex items-center justify-center
    overflow-hidden
    backdrop-blur-none opacity-0 transition-all;

  bottom: 0;
  z-index: 3;

  &--visible {
    @apply backdrop-blur opacity-100;
  }
}

.ProgressSpinner__inner {
  @apply relative
    rounded-full
    transition-transform;

  transition-duration: 400ms;
  transform: translate3d(0, 20%, 0);

  .ProgressSpinner--visible & {
    transform: translate3d(0, 0, 0);
  }
}

.ProgressSpinner__circle-svg {
  @apply relative;
  width: 42px;
  height: 42px;
  transform: rotate(-90deg);
}

.ProgressSpinner__circle {
  stroke-linecap: butt;
  stroke-opacity: 1;
  stroke-width: 2;
  fill: transparent;
}
</style>
